import React from 'react';
import PropTypes from 'prop-types';
import Script from "next/script"
import config from '../../../config';
import DOMPurify from 'isomorphic-dompurify';
import { customJsonstringify } from '../../../utils/helpers/customJsonstringify.helpers';

class SEOBreadcrumb extends React.PureComponent {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };

  render() {
    const { locale, data } = this.props;
    const breadcrumbData = [];
    data.map(breadcrumbItem => {
      let bc_obj;
      let item_url = config.siteUrl + breadcrumbItem.props.to;
      bc_obj = {
        '@type': 'ListItem',
        position: breadcrumbItem.props.keyIndex + 1,
        name: breadcrumbItem.props.labelText,
        item: item_url,
      };
      breadcrumbData.push(bc_obj);
    });
    const breadcrumbDataJSON = customJsonstringify(breadcrumbData);
    const seoConfig = require(`../../../data/${locale}/seo.json`);
    return (
      <>
        <Script
          id='seobreadcrumb'
          type="application/ld+json"
          strategy='afterInteractive'
          dangerouslySetInnerHTML={{
            __html:DOMPurify.sanitize( ` { 
                "@context": "${seoConfig.context}",
                "@type": "BreadCrumbList",
                "itemListElement": ${breadcrumbDataJSON}
            }
            `),
          }}
        />
      </>
    );
  }
}

export default SEOBreadcrumb;
